import { wsUrl } from "./serverUrl";
import { quality, smooth } from "./netquality";
import { ClientMsg, PROTOCOL_VERSION, ServerMsg, decode, encode } from "../shared/protocol";

export class Net {
  ws?: WebSocket;
  onmsg: (m: ServerMsg) => void = () => {};
  onclose: () => void = () => {};
  rtt = 0; // last round trip
  rttAvg = 0; // smoothed
  private lastMsg = performance.now();
  /** 3 good, 2 fair, 1 poor, 0 stalled (see netquality.ts) */
  get quality() {
    return quality(this.rttAvg, performance.now() - this.lastMsg);
  }
  private pinger?: number;
  connect(room: string, key: string, machine: number, watch = false, token = ""): Promise<void> {
    return new Promise((resolve, reject) => {
      const ws = (this.ws = new WebSocket(wsUrl()));
      ws.onopen = () => {
        this.send({ t: "join", v: PROTOCOL_VERSION, room, key, machine, ...(watch ? { watch: true } : {}), ...(token ? { token } : {}) });
        this.lastMsg = performance.now();
        this.send({ t: "ping", ts: performance.now() });
        this.pinger = window.setInterval(() => this.send({ t: "ping", ts: performance.now() }), 2000);
        resolve();
      };
      ws.onerror = () => reject(new Error("connection failed"));
      ws.onclose = () => (clearInterval(this.pinger), this.onclose());
      ws.onmessage = (e) => {
        const m = decode<ServerMsg>(String(e.data));
        if (!m) return;
        this.lastMsg = performance.now();
        if (m.t === "pong") (this.rtt = performance.now() - m.ts), (this.rttAvg = smooth(this.rttAvg, this.rtt));
        this.onmsg(m);
      };
    });
  }
  send(m: ClientMsg) {
    if (this.ws?.readyState === WebSocket.OPEN) this.ws.send(encode(m));
  }
  /** Milliseconds since the server last said anything (it pings back every 2 s, and sends states 20 times a second in a race). */
  get silentMs() {
    return performance.now() - this.lastMsg;
  }
  get open() {
    return this.ws?.readyState === WebSocket.OPEN;
  }
  /** Drops a connection that has gone quiet, so the normal reconnection takes over. */
  drop() {
    this.ws?.close();
  }
  closing = false; // set when the player leaves on purpose (no automatic reconnection then)
  close() {
    this.closing = true;
    this.send({ t: "leave" });
    this.ws?.close();
  }
}
